import { api } from '@api'

interface GetToAuthorizeResponse {
  toAuthorize: number | undefined
}

const getToAuthorize = async () => {
  const response = await api.get<GetToAuthorizeResponse>('/tickets/to-authorize/count')
  return response.data.toAuthorize
}

export { getToAuthorize }
